module.exports = __webpack_public_path__ + "static/media/rfbased5.f48363f2.jpg";